import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PublicPageInfoFragmentDoc } from './PageInfo.generated'
import * as Types from './public_graphql'

export const GetPublicCategoriesWithSubDocument = gql`
  query GetPublicCategoriesWithSub(
    $after: String
    $before: String
    $filters: CategoriesQueryFiltersInput
    $first: Int
    $last: Int
    $sorts: [CategoriesQuerySortsInput!]
    $filtersWithSub: CategoriesQueryFiltersInput
  ) {
    categories(after: $after, before: $before, filters: $filters, first: $first, last: $last, sorts: $sorts) {
      edges {
        node {
          id
          name
          parent {
            id
          }
          categories(filters: $filtersWithSub) {
            edges {
              node {
                id
                name
                parent {
                  id
                }
              }
            }
          }
        }
      }
      pageInfo {
        ...PublicPageInfo
      }
    }
  }
  ${PublicPageInfoFragmentDoc}
` as unknown as DocumentNode<Types.GetPublicCategoriesWithSubQuery, Types.GetPublicCategoriesWithSubQueryVariables>
